export default __webpack_public_path__ + "static/media/expl_12_EN.0c7e37fd.png";